import { TouchBackend } from "react-dnd-touch-backend";
import { DndProvider } from "react-dnd";

const DndContext = ({ children }) => {
  return (
    <DndProvider
      backend={TouchBackend}
      options={{
        enableMouseEvents: true,
        ignoreContextMenu: true,
        touchSlop: 8,
      }}
    >
      {children}
    </DndProvider>
  );
};

export default DndContext;
